import React from "react";
import { connect } from "react-redux";
import _ from 'lodash';
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
//import HeaderView from "./HeaderView";
import * as d from "../../reducers/domainReducer";
import Logo from "./Logo";
import ActiveUser from "./ActiveUser";
import UsersList from "./UsersList";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import HeaderMessageBanner from "../common/HeaderMessageBanner";
import MyChartProxyButton from './MyChartProxyButton';
import { Modal, ModalBody } from 'reactstrap';
import MobileActiveUser from './MobileActiveUser'
import HeaderDivider from "./HeaderDivider";

/**
 * Page header component.
 * 
 * @returns {any} header.
 */
class Header extends React.Component {
    constructor(props) {
        super(props);
        const { currentPharmacyUser, currentMyChartUser, history } = this.props;
        this.state = {
            activeUser: currentPharmacyUser ? currentPharmacyUser : currentMyChartUser,
            pageScrolledClass: "",
            modalVisible: false,
            openHeaderMessage: false,
            showAccordionButton: false,
            scrolledPastOffset: false,
            scrollOffsetForProxySelector: false,
        };
        this.throttle = _.throttle(this.handleScroll.bind(this), 150, { maxWait: 100 });
        this.resizeThrottle = _.throttle(this.handleResize.bind(this), 150, { maxWait: 100 });
        this.onPrimaryUserSelected = this.onPrimaryUserSelected.bind(this);
        this.onMyChartUserSelected = this.onMyChartUserSelected.bind(this);
        this.onPharmacyUserSelected = this.onPharmacyUserSelected.bind(this);
    }

    componentDidMount() {

        this.historyUnlisten = this.props.history.listen((location, action) => {

            if (!this.props.stayOnIncompleteForm && window.userToSwitch/* && this.callback*/) {
                if (this.callback) {
                    this.callback(this);
                    this.callback = null;
                }
                else {
                    if (window.userToSwitch.isPrimary) {
                        this.switchToPrimaryUser(this);
                    }
                    else if (window.userToSwitch.index) {
                        this.switchToMyChartUser(this);
                    }
                    else {
                        this.switchToPharmacyUser(this);
                    }
                }
            }
            if (!window.userToSwitch) {
                this.props.resetStayOnIncompleteForm();
            }
        });

        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.throttle);
            window.addEventListener('resize', this.resizeThrottle);
        }

        this.enableAccordionButton();
        console.info("Header BSW_QSI", BSW_QSI);
        this.verifyAndEnableThirdPartyScripts("qualtrics");
        this.header.classList.contains('page-scrolled-down') ? this.props.checkHeaderHeightClass(true) : this.props.checkHeaderHeightClass(false);
        logUI("MBHWeb.UI.Header.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    verifyAndEnableThirdPartyScripts(thirdPartyScriptProvider) {
        try {
            switch (thirdPartyScriptProvider) {
                case "qualtrics":
                    try {
                        console.info("Header.js verifyAndEnableThirdPartyScripts BSW_QSI", BSW_QSI);
                        if (BSW_QSI === "error") {
                            logUI("MBHWeb.UI.Header.ComponentDidMount", new Date(), Tools.getURLPath(), { "activity": "verifyAndEnableThirdPartyScripts", "third party script": "qualtrics" }, "third party script disabled");
                            this.disableQualtricsServerData();
                        }
                    } catch (err) {
                        this.disableQualtricsServerData();
                    }
                    break;
                default:
                    break;
            }
        } catch (exp) {
            console.error("Header failed to check thirdparty scripts", exp);
        }
    }
    disableQualtricsServerData() {
        let sd = window.serverData.data;
        console.warn('Head.disapbleQualtricsServerData - Qualtrics Third Party Script Not loaded. setting all enalbled qualtrics properties to false');
        for (const prop in sd) {
            if (prop.toLocaleLowerCase().includes("enablequaltrics")) {
                sd[prop] = false;
            }
        }
        window.store.dispatch({ type: types.SET_SERVER_DATA, serverData: sd });
    }
    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.throttle);
        }

        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    onViewAllSelected = (user) => {
        if (this.blockUserSwitch()) {
            this.openModal();
        } else {
            this.props.switchToMyChartUser(user, true, 0);
            this.setState({ activeUser: user });
        }
    }

    updateActiveUser = (user) => {
        this.setState({ activeUser: user });
    }

    onPrimaryUserSelected(user) {
        //this.props.markUserToSwitch({ ...user, isPrimary: true });

        // resorting to window.userToSwitch as the reducer falls behind... 
        // especially when checking the state variable of userToSwitch on a Link click behind ConfirmationModal, where it's 
        // particularly consumed with the option that the browser back button is allowed to leave a changing form without confirmation
        if (this.blockUserSwitch()) {
            this.openModal();
        } else {
            window.userToSwitch = { ...user, isPrimary: true };
            this.callback = this.switchToPrimaryUser;
        }
    }

    onMyChartUserSelected(user) {
        //this.props.markUserToSwitch(user);
        if (this.blockUserSwitch()) {
            this.openModal();
        } else {
            window.userToSwitch = { ...user, isPrimary: false };
            this.callback = this.switchToMyChartUser;
        }
    }

    onPharmacyUserSelected(user) {
        //this.props.markUserToSwitch(user);
        if (this.blockUserSwitch()) {
            this.openModal();
        } else {
            window.userToSwitch = { ...user, isPrimary: false };
            this.callback = this.switchToPharmacyUser;
        }
    }

    onFamilyPlanUserSelected(user) {
        //To-do 
    }

    switchToPrimaryUser(thisObj) {
        const user = window.userToSwitch;
        const { rxDown, hasPharmacy, /*switchToPharmacyUser, switchToMyChartUser,*/ bundle, history } = this.props;
        const { activeUser } = this.state;
        if (!rxDown && hasPharmacy && (bundle === 'pharmacy' || history && history.location.pathname.indexOf('/pharmacy') > -1)) {
            this.props.switchToPharmacyUser(user);
        }
        else {
            this.props.switchToMyChartUser(user, false, 0);
        }
        //        this.getPatientPhoto();
        logUI("MBHWeb.Proxy.PrimaryUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
        thisObj.setState({ activeUser: user });
        window.userToSwitch = null;
    }

    switchToMyChartUser(thisObj) {
        const user = window.userToSwitch;
        const { currentMyChartUser, /*switchToMyChartUser,*/ bundle } = this.props;
        const { activeUser } = this.state;
        if (user !== activeUser || user.externalId !== currentMyChartUser.externalId) {
            this.props.switchToMyChartUser(user, false, user.index ? user.index : 0);
            //            this.getPatientPhoto();
            logUI("MBHWeb.Proxy.MyChartUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
            thisObj.setState({ activeUser: user });
            window.userToSwitch = null;
        }
    }

    switchToPharmacyUser(thisObj) {
        const user = window.userToSwitch;
        const { /*switchToPharmacyUser,*/ bundle } = this.props;
        const { activeUser } = this.state;
        this.props.switchToPharmacyUser(user);
        logUI("MBHWeb.Proxy.PharmacyUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
        thisObj.setState({ activeUser: user });
        window.userToSwitch = null;
    }

    enableAccordionButton = () => {
        if (this.header && this.header.firstChild) {
            const { showAccordionButton } = this.state;
            const headerMsgBanner = this.header.firstChild.children[0];

            if (headerMsgBanner && headerMsgBanner.classList.contains('header-message-banner-container')) {
                if (headerMsgBanner.scrollHeight > 57) {
                    if (showAccordionButton !== true)
                        this.setState({ showAccordionButton: true });
                } else if (showAccordionButton !== false) {
                    this.setState({ showAccordionButton: false });
                }
            }
        }
    }

    handleResize(event) {
        if (typeof window !== 'undefined') {
            const scrollY = window.pageYOffset;
            const { headerMessage, showVersionUpdateBanner, showServiceDownBanner, isMyChartInactivated } = this.props;
            const hasHeaderMessage = headerMessage && headerMessage !== null ? true : false;
            const showHeaderMessage = hasHeaderMessage || showVersionUpdateBanner || showServiceDownBanner || isMyChartInactivated;

            if (showHeaderMessage) {
                this.enableAccordionButton();
            }
        }
    }

    handleScroll(event) {
        if (typeof window !== 'undefined') {
            const { headerMessage, showVersionUpdateBanner, showServiceDownBanner, isMyChartInactivated,
                checkHeaderHeightClass, isHeaderShrinked, isDashboardPage } = this.props;
            const { scrolledPastOffset, scrollOffsetForProxySelector } = this.state;
            const isMobile = this.getIsMobile();
            const scrollY = window.pageYOffset;
            const topOffsetHeight = isDashboardPage && isMobile ? 60 : 110; // Height of header plus margin bottom
            const hasHeaderMessage = headerMessage && headerMessage !== null ? true : false;
            const showHeaderMessage = hasHeaderMessage || showVersionUpdateBanner || showServiceDownBanner || isMyChartInactivated;
            const topProxyselectorOffsetHeight = isDashboardPage && isMobile ? 165: 110;
            // console.log(scrollY, topProxyselectorOffsetHeight, "scrollY", "topProxyselectorOffsetHeight");
            if (scrollY > topOffsetHeight) {
                if ((this.state.scrollTop + topOffsetHeight) < scrollY) {
                    this.setState({
                        scrollTop: scrollY,
                        pageScrolledClass: showHeaderMessage ? " msg-page-scrolled-down" : " page-scrolled-down"
                    });
                    if (!isHeaderShrinked) {
                        checkHeaderHeightClass(true);
                    }
                }
                else if ((this.state.scrollTop - topOffsetHeight) > scrollY) {
                    this.setState({
                        scrollTop: scrollY,
                        pageScrolledClass: showHeaderMessage ? " msg-page-scrolled-up" : " page-scrolled-up"
                    });
                    if (isHeaderShrinked) {
                        checkHeaderHeightClass(false);
                    }
                }
                if (!scrolledPastOffset) {
                    this.setState({
                        scrolledPastOffset: true
                    });
                }
            }
            else {
                this.setState({
                    scrollTop: scrollY,
                    pageScrolledClass: ""
                });
                if (isHeaderShrinked) {
                    checkHeaderHeightClass(false);
                }
                if (scrolledPastOffset) {
                    this.setState({
                        scrolledPastOffset: false
                    });
                }
            }

            if (scrollY > topProxyselectorOffsetHeight) {
                if (!scrollOffsetForProxySelector) {
                    this.setState({
                        scrollOffsetForProxySelector: true
                    });
                }
            }
            else {
                if (scrollOffsetForProxySelector) {
                    this.setState({
                        scrollOffsetForProxySelector: false
                    });
                }
            }
        }
    }

    getPatientPhoto() {
        if (window && window.serverData.data.enablePatientPhoto && this.props.hasMyChart) {
            this.props.getPatientPhoto();
        }
    }

    blockUserSwitch() {
        return this.props && this.props.history && this.props.history.location && this.props.history.location.pathname && this.props.history.location.pathname.toLowerCase().indexOf("/findcare/vaccine") !== -1;
    }

    openModal = () => {
        logUI("MBHWeb.UI.Header.Proxy.SwitchBlocked", new Date(), Tools.getURLPath());
        this.setState({ modalVisible: true });
    }

    closeModal = () => {
        logUI("MBHWeb.UI.Header.Proxy.SwitchBlocked.Modal.Close", new Date(), Tools.getURLPath());
        this.setState({ modalVisible: false });
    }

    toggleHeaderMessage = () => {
        this.setState({ openHeaderMessage: !this.state.openHeaderMessage });
    }

    getIsMobile = () => {
        const { screenBreakPoint } = this.props;

        return !(screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
    }

    onFamilyManagementClick = (enableFamilyManagementTooltip) => {
        const { updateFamilyManagementToolTipPreference, history } = this.props;
        if (enableFamilyManagementTooltip) {
            updateFamilyManagementToolTipPreference();
            logUI("MBHWeb.UI.Header.Proxy.AddFamily.Clicked", new Date(), Tools.getURLPath(), null, 'FamilyManagementTooltipShowing');
        } else {
            logUI("MBHWeb.UI.Header.Proxy.AddFamily.Clicked", new Date(), Tools.getURLPath());
        }
        history.push("/proxymanagement");
    }


    render() {
        const { updateFamilyManagementToolTipPreference, showFamilyManagementToolTip,
            showGetCareToolTip, showScheduleCareTooltip, primaryUser,
            currentMyChartUser, isMyChartInactivated, currentPharmacyUser, dateTimeOffset,
            history, isDashboardPage, serverData, hideBannerOnCrash,
            age, headerMessage, showVersionUpdateBanner, showServiceDownBanner, isHeaderShrinked,
        } = this.props;
        const { activeUser, modalVisible, openHeaderMessage, showAccordionButton, scrolledPastOffset, scrollOffsetForProxySelector } = this.state;
        const hasHeaderMessage = headerMessage && headerMessage !== null ? true : false;
        const showHeaderMessage = hasHeaderMessage || showVersionUpdateBanner || showServiceDownBanner || isMyChartInactivated;
        const patientPhoto = this.props.patientPhoto && this.props.patientPhoto.response ? this.props.patientPhoto.response.data : null;
        const isAdult = age && age > 17 ? true : false;
        const enableFamilyManagementTooltip = isAdult && showFamilyManagementToolTip && !showGetCareToolTip && !showScheduleCareTooltip && isDashboardPage && !((typeof window !== 'undefined') && window.document.querySelector("body").classList.contains("modal-open")); //check if the body already has the 'modal-open' class. If this class is present, we do not show the proxy tooltip in the header
        const msgHeader = showHeaderMessage ? " msg-header" : "";
        const shortHeader = isDashboardPage ? " header-shorten" : "";
        const headerStyle = enableFamilyManagementTooltip ? { zIndex: '1001' } : {};
        const pathname = history && history.location ? history.location.pathname : '/';
        const isMobile = this.getIsMobile();
        const hideProxySelector = isDashboardPage && !scrollOffsetForProxySelector ? "hide-proxy-selector" : "";
        const children = React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                index,
                opacity: this.state.opacity
            });
        });

        return (
            <React.Fragment>
                <div ref={(el) => (this.header = el)}
                    className={`container-fluid header ${openHeaderMessage ? 'msg-banner--open' : ''}` + this.state.pageScrolledClass + msgHeader + shortHeader}
                    style={headerStyle}
                >
                    <div className="row">
                        {showHeaderMessage &&
                            <HeaderMessageBanner
                                ref={(el) => (this.headerMsgBanner = el)}
                                hasHeaderMessage={hasHeaderMessage}
                                headerMessage={headerMessage}
                                showAccordionButton={showAccordionButton}
                                showHeaderMessage={showHeaderMessage}
                                showVersionUpdateBanner={showVersionUpdateBanner}
                                showServiceDownBanner={showServiceDownBanner}
                                toggleHeaderMessage={this.toggleHeaderMessage}
                                isMyChartInactivated={isMyChartInactivated}
                            />
                        }
                        <div className="col-12 maxWidth-content header-proxy-dropdown">
                            <div className="row header__main align-items-center">
                                <Logo containerClass="col-3 header__logo" currentPharmacyUser={currentPharmacyUser} />
                                <div className={`col-9 header__active-users ${hideProxySelector}`}>
                                    <UsersList
                                        primaryUser={primaryUser} activeUser={activeUser}
                                        currentMyChartUser={currentMyChartUser} currentPharmacyUser={currentPharmacyUser}
                                        onMyChartUserSelected={this.onMyChartUserSelected}
                                        onPharmacyUserSelected={this.onPharmacyUserSelected}
                                        onPrimaryUserSelected={this.onPrimaryUserSelected}
                                        onFamilyPlanUserSelected={this.onFamilyPlanUserSelected}
                                        onClick={() => { this.onFamilyManagementClick(enableFamilyManagementTooltip) }}
                                        onViewAllSelected={this.onViewAllSelected}
                                        updateActiveUser={this.updateActiveUser}
                                        isAdult={isAdult}
                                        isDashboardPage={isDashboardPage}
                                    />
                                </div>
                            </div>
                            {/*<MobileActiveUser*/}
                            {/*    containerClass="active-users-container"*/}
                            {/*    dateTimeOffset={dateTimeOffset}*/}
                            {/*    patientPhoto={patientPhoto}*/}
                            {/*    isDashboardPage={isDashboardPage}*/}
                            {/*/>*/}
                        </div>

                    </div>
                    <HeaderDivider
                        isDashboardPage={isDashboardPage}
                        isMobile={isMobile}
                        scrolledPastOffset={scrolledPastOffset}
                    />
                </div>
                {children}
                <Modal className="verify-modal" isOpen={modalVisible} toggle={() => this.closeModal()} centered>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12">
                                <p>The account cannot be switched while scheduling.</p>
                                <button type="button" className="btn text-btn" onClick={() => this.closeModal()}>
                                    OKAY
                                </button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        dateTimeOffset: state.domain.dto,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        rxDown: state.common.rxDown,
        hasPharmacy: state.memberships.isActiveFeature_Pharmacy,
        history: state.session.history,
        stayOnIncompleteForm: state.common.stayOnIncompleteForm,
        patientPhoto: state.portal.patientPhoto,
        hideBannerOnCrash: state.common.hideBannerOnCrash,
        showFamilyManagementToolTip: state.session.showFamilyManagementToolTip,
        showGetCareToolTip: state.session.showGetCareToolTip,
        showScheduleCareTooltip: state.session.showScheduleCareTooltip,
        age: state.domain.age,
        headerMessage: state.session && state.session.serverData ? state.session.serverData.headerMessage : null,
        isHeaderShrinked: state.header.isHeaderShrinked,
        screenBreakPoint: state.common.screenBreakPoint,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFamilyManagementToolTipPreference: () => {
            dispatch({ type: types.UPDATE_FAMILY_MANAGEMENT_TOOLTIP_PREFERENCE });
        },
        //markUserToSwitch: (user) => dispatch({ type: types.USER_TO_SWITCH, user }),
        resetStayOnIncompleteForm: () => dispatch({ type: types.STAY_ON_INCOMPLETE_FORM, stay: false }),
        switchToMyChartUser: (user, isSeeAllSelected, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, isSeeAllSelected, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        },
        switchToPharmacyUser: (pharmacyUser) => {
            if (pharmacyUser.externalId) {
                dispatch({ type: types.SWITCH_USER_SAGA, user: pharmacyUser, index: pharmacyUser.index || 0 });
            }
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser });
        },
        getPatientPhoto: () => dispatch({ type: types.PATIENT_PHOTO_START }),
        updateShowBanner: () => dispatch({ type: types.GRAPHIC_BANNER_UPDATE }),
        checkHeaderHeightClass: (isClassVisible) => dispatch({ type: types.IS_HEADER_SHRINKED, isClassVisible: isClassVisible })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);